import { useRouterExtended } from "@/global/hooks/useRouterExtended";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { createTimeoutWorker } from "./create-timeout-worker";
import { calcTimeoutDuration, calcTimeoutType } from "./utils.timeoutWorker";
import React from "react";
import { useTimeoutWarningModals } from "./useTimeoutWarningModals";
import { useCartNavigationHelper } from "../useCartBackButtonHelper";

export const useTimeoutWorker = () => {
  const router = useRouterExtended();
  const teamConfig = useTeamConfig();
  const { fireWarningModal, fireExpiredModal } = useTimeoutWarningModals();
  const { backToFindGames } = useCartNavigationHelper();
  const type = calcTimeoutType(teamConfig, router);
  const {timeoutDuration, warningDuration} = calcTimeoutDuration(teamConfig, type); // prettier-ignore

  const onTick = (worker: ReturnType<typeof createTimeoutWorker>) => {
    if (!worker) return;
    const { timeElapsed, warningDuration, isWarningFired } = worker;
    // if warning time elapsed and warning modal not fired, fire warning modal
    const isWarningTimeElapsed = timeElapsed >= warningDuration;
    if (!isWarningFired && isWarningTimeElapsed) {
      fireWarningModal(worker);
      worker.isWarningFired = true;
    }
  };

  const onTimeout = () => {
    fireExpiredModal();
    backToFindGames();
  };

  const timeoutWorker = createTimeoutWorker({
    name: type,
    duration: timeoutDuration,
    warningDuration,
    init: Boolean(type),
    onTick,
    onTimeout,
  });

  React.useEffect(() => {
    window.getTimeoutWorker = () => timeoutWorker;
  }, []);

  return {
    timeoutWorker,
    isTimeoutEnabled: !!timeoutWorker && Boolean(type),
  };
};
